import { connect } from 'react-redux'
import LocationSearch from '../../components/trips/locations/LocationSearch'
import * as actions from '../../state/actions/trips'
import { clearMap, actionCreators as mapsActionCreators } from '../../state/actions/google_map'
import * as riderActions from '../../state/actions/riders'
import * as riderLocationActions from '../../state/actions/rider-locations'
import { getRiderById } from '../../state/reducers/riders'
import { getRiderLocationsList } from '../../state/reducers/rider-location'
import {
  REMOVE_ADDITIONAL_STOP_FROM_TRIP_REQUEST,
  SET_ADDITIONAL_STOP_TO_TRIP_REQUEST,
  SET_DESTINATION_TO_TRIP_REQUEST,
  SET_ORIGIN_TO_TRIP_REQUEST
} from '../../state/constants'
import {
  getDropoffAutoComplete,
  getFavoriteTrips,
  getPickupAutoComplete,
  getRecentTrips,
  filterRiderLocations,
  getAdditionalStopAutoComplete
} from '../../state/selectors/'
import { IStoreState, IRiderLocationObject, ILocationV2 } from '../../types/'

//TODO: Refactor location search so it is more generic.
//Right now it is coupled tightly to CreateTripPane,
//and assumes it will only be used for creating a trip
export function mapStateToProps(state: IStoreState, ownProps: any): any {
  //TODO: This is halfway between true multi-rider trips and assuming
  //only one rider. This will work for now and bridge the gap for the future.
  const tripInfo = state.tripRequest.request || ({} as any)
  const { riderId } = ownProps
  const { additionalStop, details, dropoffLocation, pickupLocation } = tripInfo
  return {
    riderId,
    rider: getRiderById(state.riders, riderId),
    pickup: pickupLocation,
    dropoff: dropoffLocation,
    details,
    additionalStop,
    pickupAutoComplete: getPickupAutoComplete(state),
    dropoffAutoComplete: getDropoffAutoComplete(state),
    additionalStopAutoComplete: getAdditionalStopAutoComplete(state),
    recentTrips: getRecentTrips(state, 2),
    favoriteTrips: getFavoriteTrips(state, 2),
    locations:
      state.riderLocations.query === ''
        ? getRiderLocationsList(state.riderLocations)
        : filterRiderLocations(state, state.riderLocations.query),
    metadata: state.riderLocations.metadata
  }
}

export function mapDispatchToProps(dispatch: any, ownProps: any) {
  return {
    swapLocations: (params: { pickup: ILocationV2; dropoff: ILocationV2 }) => {
      dispatch(actions.actionCreators.resetSelectedTripRequestProduct())
      if (params.dropoff.latitude && params.pickup.latitude) {
        dispatch(
          mapsActionCreators.setOrigin({
            lat: params.dropoff.latitude,
            lng: params.dropoff.longitude
          })
        )
        dispatch(
          mapsActionCreators.setDestination({
            lat: params.pickup.latitude,
            lng: params.pickup.longitude
          })
        )
        dispatch(
          mapsActionCreators.replaceMarkers('origin', [
            {
              type: 'origin',
              lat: params.dropoff.latitude,
              lng: params.dropoff.longitude
            }
          ])
        )
        dispatch(
          mapsActionCreators.replaceMarkers('destination', [
            {
              type: 'destination',
              lat: params.pickup.latitude,
              lng: params.pickup.longitude
            }
          ])
        )
      }
      return dispatch(actions.actionCreators.swapLocations())
    },
    showPickupAutoComplete: (e: any) => dispatch(actions.searchPickup(e.target.value, ownProps.bounds)),
    showDropoffAutoComplete: (e: any) => dispatch(actions.searchDropoff(e.target.value, ownProps.bounds)),
    showAdditionalStopComplete: (e: any, index: number) =>
      dispatch(actions.searchAdditionalStop(e.target.value, index, ownProps.bounds)),
    clearAutoComplete: () => dispatch(actions.actionCreators.onClearAutoComplete()),
    clearLocationSearch: () => dispatch(actions.actionCreators.clearLocationSearch()),
    clearMap: () => dispatch(clearMap()),
    selectPickup: (locationInfo: any) => dispatch(actions.selectLocation(locationInfo, SET_ORIGIN_TO_TRIP_REQUEST)),
    selectDropoff: (locationInfo: any) =>
      dispatch(actions.selectLocation(locationInfo, SET_DESTINATION_TO_TRIP_REQUEST)),
    selectAdditionalStop: (locationInfo: any) =>
      dispatch(actions.selectLocation(locationInfo, SET_ADDITIONAL_STOP_TO_TRIP_REQUEST)),
    changeAdditionalStopOrder: (draggedIndex: number, draggedOverIndex: number) => {
      dispatch(actions.actionCreators.changeAdditionalStopOrder({ draggedIndex, draggedOverIndex }))
      // Update map view to reflect the new order of additional stops
      dispatch(mapsActionCreators.updateAdditionalStopSequence(draggedIndex, draggedOverIndex))
    },
    changeLocationsOrder: (draggedIndex: number, draggedOverIndex: number) => {
      dispatch(actions.actionCreators.changeLocationsOrder({ draggedIndex, draggedOverIndex }))
      // Update map view to reflect the new order of locations
      dispatch(mapsActionCreators.updateLocationSequence(draggedIndex, draggedOverIndex))
    },
    removeAdditionalStop: (locationInfo: any) =>
      dispatch(actions.selectLocation(locationInfo, REMOVE_ADDITIONAL_STOP_FROM_TRIP_REQUEST)),
    getRiderLocationList: (riderId: string): any => dispatch(riderActions.getRiderLocationList(riderId)),
    setRiderLocationQuery: (query: string) =>
      dispatch(riderLocationActions.actionCreators.setRiderLocationQuery(query)),
    saveLocation: (
      riderId: string,
      location: IRiderLocationObject,
      locationType: string,
      locations: IRiderLocationObject[],
      index?: number
    ) => dispatch(riderLocationActions.saveRiderLocation(riderId, location, locationType, locations, index)),
    setDropoffPhoneNumber: (phone: string) => dispatch(actions.actionCreators.setDropoffPhoneNumber(phone)),
    setPickupPhoneNumber: (phone: string) => dispatch(actions.actionCreators.setPickupPhoneNumber(phone)),
    setTripReqDetails: (payload: any) => dispatch(actions.actionCreators.setTripReqDetails(payload))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LocationSearch)



// WEBPACK FOOTER //
// ./src/containers/trips/LocationSearch.ts